export default __webpack_public_path__ + "static/AA081210_Citation_680-0093-01a_540x358-300x198-4573c7349c843d2aca4a66978a42dd96.jpg";